export default "__VITE_ASSET__Bq5lkVSl__"